import { render, staticRenderFns } from "./Type3b.vue?vue&type=template&id=b7dd9068&"
import script from "./Type3b.vue?vue&type=script&lang=js&"
export * from "./Type3b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports